import React from 'react';
import CoursesIndex from '../components/course/pages/CoursesIndex';

const CoursesPage = () => {
  return (
    <div>
      <CoursesIndex />
    </div>
  );
};

export default CoursesPage;
